import React, {Component} from 'react';
import base from '../base';
import Order from './Order';

class Checkout extends Component {
  state = {
    fishes: {},
    order: {}
  };

  componentDidMount(){
    const params = this.props.match.params.storeId;
    const localStorageRef = localStorage.getItem(params)
    if(localStorageRef){
      this.setState({ order: JSON.parse(localStorageRef) });
    }
    this.ref = base.syncState(`${params}/fishes`, {
      context: this,
      state: 'fishes'
    });
    console.log(Object.keys(this.state.order));
  };

  componentDidUpdate(){
    localStorage.setItem(
      this.props.match.params.storeId, JSON.stringify(this.state.order)
    )
  };

  goToStore = e => {
    this.props.history.push(`/store/fintastic`);
  }

  render(){
    return(
      <div>
        <h1>This is where we will add the checkout later</h1>
        <button onClick={this.goToStore}>Back to Store</button>
          <Order
            fishes={this.state.fishes}
            order={this.state.order}
            removeFromOrder={this.removeFromOrder}
            history={this.props.history}
          />
      </div>

    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/components/Checkout.js